/**
 * Days of the week as the schedule APIs number them: Monday is 0, matching
 * Python's `date.weekday()`.
 */
export const WEEKDAY_OPTIONS = [
    { value: 0, label: 'Monday', shortLabel: 'Mon', chipLabel: 'Mo' },
    { value: 1, label: 'Tuesday', shortLabel: 'Tue', chipLabel: 'Tu' },
    { value: 2, label: 'Wednesday', shortLabel: 'Wed', chipLabel: 'We' },
    { value: 3, label: 'Thursday', shortLabel: 'Thu', chipLabel: 'Th' },
    { value: 4, label: 'Friday', shortLabel: 'Fri', chipLabel: 'Fr' },
    { value: 5, label: 'Saturday', shortLabel: 'Sat', chipLabel: 'Sa' },
    { value: 6, label: 'Sunday', shortLabel: 'Sun', chipLabel: 'Su' },
] as const;

export const WEEKDAYS: ReadonlyArray<
    (typeof WEEKDAY_OPTIONS)[number]['label']
> = WEEKDAY_OPTIONS.map(({ label }) => label);

export function weekdayName(day: number): string {
    return (
        WEEKDAY_OPTIONS.find((option) => option.value === day)?.label ??
        `Day ${day}`
    );
}
